export default __webpack_public_path__ + "static/media/AE24.7f58fb9e.jpg";